import { render } from "./Main.vue?vue&type=template&id=259a90db"
const script = {}
script.render = render

export default script